export const QK = {
  userProfile: "userProfile",
  client: "client",
  clients: "clients",
  searchClients: "searchClients",
  personalContacts: "personalContacts",
  gpContacts: "gpContacts",
  professionalContacts: "professionalContacts",
  eventData: "eventData",
  formFields: "formFields",
  allForms: "allForms",
  formName: "formName",
  subCategory: "subCategory",
  AllInitialAssessment: "AllInitialAssessment",
  allergyTypes: "allergyTypes",
  allergies: "allergies",
  selectedAllergy: "selectedAllergy",
  photographData: "photographData",
  customerDetails: "customerDetails",
  dnacpr: "dnacpr",
  lpa: "lpa",
  dols: "dols",
  record: "record",
  observations: "observations",
  weights: "weights",
  wellbeings: "wellbeings",
  respirations: "respirations",
  sugars: "sugars",
  temperatures: "temperatures",
  oxygen_saturations: "oxygen_saturations",
  pulse_rates: "pulse_rates",
  fluid_levels: "fluid_levels",
  domCare: "domCare",
  preferredCarerSuggestions: "preferredCarerSuggestions",
  blockedCarerSuggestions: "blockedCarerSuggestions",
  secAssessments: "secAssessments",
  bowelMovements: "bowelMovements",
  repositionings: "repositionings",
  abcPattern: "abcPattern",
  seizure: "seizure",
  urinalysis: "urinalysis",
  infection: "infection",
  services: "services",
  rateCards: "rateCards",
  funders: "funders",
  fundingProfiles: "fundingProfiles",
  locations: "locations",
  careplanForm: "careplanForm",
  carePlans: "carePlans",
  carePlan: "carePlan",
  activeCarePlans: "activeCarePlans",
  inactiveCarePlans: "inactiveCarePlans",
  clientDetails: "clientDetails",
  clientPaymentServices: "clientPaymentServices",
  paymentServices: "paymentServices",
  visits: "visits",
  visitDetails: "visitDetails",
  checklist: "checklist",
  checklistItem: "checklistItem",
  runs: "runs",
  assignedClientAssessments: "assignedClientAssessments",
  assignedClientAssessmentDetail: "assignedClientAssessmentDetail",
  assignedAssessments: "assignedAssessments",
  unAssignedTasks: "unAssignedTasks",
  location: "location",
  subLocations: "subLocations",
  templates: "templates",
  employees: "employees",
  buildHistory: "buildHistory",
  scheduledRunVisits: "scheduledRunVisits",
  previousBuildHistory: "previousBuildHistory",
  candidates: "candidates",
  candidate: "candidate",
  candidateSkills: "candidateSkills",
  candidateWeeklyHistory: "candidateWeeklyHistory",
  clientArea: "clientArea",
  runsByArea: "runsByArea",
  scheduleJobByVisit: "scheduleJobByVisit",
  visitPlan: "visitPlan",
  searchCareers: "searchCareers",
  scheduleJobDetails: "scheduleJobDetails",
  weeklyAssignment: "weeklyAssignment",
  assignmentDetails: "assignmentDetails",
  scheduleTimeline: "scheduleTimeline",
  clientMedications: "clientMedications",
  visitMedication: "visitMedication",
  medicationEvents: "medicationEvents",
  alerts: "alerts",
  latestAlerts: "latestAlerts",
  handovers: "handovers",
  medicineLists: "medicineLists",
  medicineNames: "medicineNames",
  medicationDetails: "medicationDetails",
  notStartedJobs: "notStartedJobs",
  needsAttentionJobs: "needsAttentionJobs",
  dailyJobs: "dailyJobs",
  candidateEmployment: "candidateEmployment",
  candidateWorkingPattern: "candidateWorkingPattern",
  weightLists: "weightLists",
  tempLists: "tempLists",
  oxygenLists: "oxygenLists",
  fluidLists: "fluidLists",
  bowelLists: "bowelLists",
  visitCareplans: "visitCareplans",
  actionJobs: "actionJobs",
  actionIssuesJobs: "actionIssuesJobs",
  notesData: "notesData",
  candidateNotes: "candidateNotes",
  incidentList: "incidentList",
  incidentDetails: "incidentDetails",
  areas: "areas",
  dolsList: "dolsList",
  recordAbense: "recordAbense",
  NEWS2lists: "NEWS2lists",
  unallocatedCandidates: "unallocatedCandidates",
  consentAssessments: "consentAssessments",
  consentReasons: "consentReasons",
  decisionMakers: "decisionMakers",
  capacityAssessmentByReason: "capacityAssessmentByReason",
  assessmentForms: "assessmentForms",
  assessmentForm: "assessmentForm",
  environmentalAssessments: "environmentalAssessments",
  environmentalQuestions: "environmentalQuestions",
  abbeyPainScales: "abbeyPainScales",
  capabilityAssessments: "capabilityAssessments",
  chokingAssessments: "chokingAssessments",
  cornelDepressions: "cornelDepressions",
  riskTypes: "riskTypes",
  risks: "risks",
  geriatricDepressionScales: "geriatricDepressionScales",
  fallsRiskAssessments: "fallsRiskAssessments",
  fireRiskAssessments: "fireRiskAssessments",
  initialOralHealthAssessments: "initialOralHealthAssessments",
  bedRailAssessments: "bedRailAssessments",
  issueTypes: "issueTypes",
  bodyMaps: "bodyMaps",
  positions: "positions",
  commuicationNotes: "communicationNotes",
  holidays: "holidays",
  vaccinations: "vaccinations",
  vaccinationRecords: "vaccinationRecords",
  temporaryUsers: "temporaryUsers",
  dayTimelineData: "dayTimelineData",
  capacityReport: "capacityReport",
  clientsWeeklyTimeline: "clientsWeeklyTimeline",
  clientsDayTimeline: "clientsDayTimeline",
  careObservations: "careObservations",
  medicalConditions: "medicalConditions",
  carePlanReviews: "carePlanReviews",
  conversations: "conversations",
  chatHistory: "chatHistory",
  taskDetails: "taskDetails",
  assessmentSchema: "assessmentSchema",
  initAssessmentResponses: "initAssessmentResponses",
  holidayBalance: "holidayBalance",
  holidaySummary: "holidaySummary",
  dashboardStats: "dashboardStats",
  documentCategories: "documentCategories",
  documents: "documents",
  medicationrefillhistory: "medicationrefillhistory",
};
